import {
  DEFAULT_COEFFICENT,
  ITEM_TYPES,
  PRICE,
  QUOTE_INSTALLER_TYPES,
  VAT,
} from '@/common/constants';

const formatItemToQuoteType = ({ item, source, destination }) => {
  const test = `${source}_${destination}`;
  const sku = item.product?.main_sku || item.sku;
  const name = item.product?.name || item.name;

  switch (test) {
    case `${ITEM_TYPES.cart}_${ITEM_TYPES.installer}`:
    case `${ITEM_TYPES.wishlist}_${ITEM_TYPES.installer}`:
      return {
        coefficient: DEFAULT_COEFFICENT,
        label: name,
        quantity: item.quantity,
        sku,
        type: QUOTE_INSTALLER_TYPES.PRODUCT,
        type_price: PRICE.NET, // Net by default
        // TODO: To be deleted if not used
        // unit_price:
        //   item.net_price || item.product?.price_and_stock?.price?.customer_price,
        vat: item.tva_rate || VAT[0].value,
      };
    case `${ITEM_TYPES.cart}_${ITEM_TYPES.draft}`:
    case `${ITEM_TYPES.wishlist}_${ITEM_TYPES.draft}`:
    case `${ITEM_TYPES.installer}_${ITEM_TYPES.draft}`:
    case `${ITEM_TYPES.quote}_${ITEM_TYPES.draft}`:
      return {
        quantity: item.quantity,
        sku,
      };
    default:
      return item;
  }
};

export default formatItemToQuoteType;
